import Configuration from '@/agilis/util/Configuration'
import FiltersDialog from '@/agilis/components/DataFilter/FilterDialog/FilterDialog.vue'

import { mapGetters, mapActions } from 'vuex'
import i18n from '@/i18n/i18n'

// Mixin providing filter methods
// Dependencies:
// - authoizationMixin
// - dumpUserActionMixin
export default {
  name: 'DataTableFilterMixin',

  props: {
    configuration: Object
  },

  components: {
    FiltersDialog
  },

  data () {
    return {
      filterArray: [],
      implicitFilters: [],
      filterName: null,
      filterId: null,
      filterHeaders: []
    }
  },

  computed: {
    ...mapGetters({
      'selectedContext': 'contextStore/selectedContext',
      'tabId': 'contextStore/tabId',
      userActivities: 'userActivityStore/userActivities'
    }),

    filterableFields () {
      const columns = Object.values(this.dataTableConfiguration.columns)
      return Configuration.auth.searchFilterableFields(columns, this.selectedContext)
    },

    filterRoute () {
      let route = `/api/${this.applicationId}`
      if (this.workspaceId) {
        route += `/workspace/${this.workspaceId}`
      }
      if (this.trackerTypeId) {
        route += `/${this.tabId}/${this.trackerTypeId}`
      }
      return route
    },

    availableHeaders () {
      const headers = Configuration.auth.getAvailableHeaders(this.dataTableConfiguration, this.selectedContext)
      return headers
    },
    computedHeaders () {
      const ff = (this.filterHeaders && this.filterHeaders
        .map(header => this.availableHeaders.find(h => h.value === header.value))
        .concat(this.headers.find(header => header.value === 'actions'))) || this.headers

      return ff.filter(Boolean)
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError'
    }),

    userCanFilter () {
      return this.dataTableConfiguration.enableFilters
    },

    applyFilter (filter = null) {
      if (filter && filter.locale && filter.locale !== i18n.locale) {
        // Invalid filter: configured on a locale different from current: abort the apply of the filter
        this.notifyError({ message: this.$t('label.filterLocaleError', { name: filter.name }) })

        filter = null
      }
      const filterTerms = (filter && filter.filterTerms) || []

      // Mapping filterTerms (+ user visibility filter)
      this.filterArray = [
        ...this.implicitFilters,
        this.userCanViewOwned() ? { field: 'createdBy', operator: 'EQUALS', value: this.userId } : null, // owned: prepend this filter
        ...filterTerms
      ].filter(Boolean)

      this.filterName = filter && filter.name
      this.filterId = filter && filter.id
      this.filterHeaders = filter && filter.filterHeaders

      // Mapping sortTerms into dataTable options
      const defaultSort = Array.isArray(this.dataTableConfiguration.sortBy) && this.dataTableConfiguration.sortBy.length > 0
        ? [
          {
            sortField: this.dataTableConfiguration.sortBy[0],
            sortType: this.dataTableConfiguration.sortDesc[0] ? 'DESC' : 'ASC'
          }
        ]
        : []

      let sortBy = []
      let sortDesc = []
      const userActivity = this.userActivities(this.dumpRoute) || defaultSort
      const sortTerms = (filter && filter.sortTerms)
      /**
       * If the filter has sortTerms, use them to sort the table
       * If not, use the userActivity sortTerms
       * If there are no userActivity sortTerms, use the default sort
       */
      if (sortTerms && Array.isArray(sortTerms)) {
        if (sortTerms.length > 0) {
          ({ sortBy, sortDesc } = sortTerms.reduce(
            (acc, ss) => {
              acc.sortBy.push(ss.sortField)
              acc.sortDesc.push(ss.sortType !== 'ASC')
              return acc
            },
            {
              sortBy: [],
              sortDesc: []
            }
          ))
        }
      } else if (sortTerms && typeof sortTerms === 'object') {
        sortBy = [sortTerms.sortField]
        sortDesc = [sortTerms.sortType !== 'ASC']
      } else {
        if (userActivity && userActivity.sortBy && userActivity.sortDesc && (userActivity.sortBy.length > 0 && userActivity.sortDesc.length > 0)) {
          sortBy = userActivity.sortBy
          sortDesc = userActivity.sortDesc
        }
      }
      this.options.sortBy = sortBy
      this.options.sortDesc = sortDesc
      this.options.page = 1

      if (this.fetchData) {
        this.fetchData()
      }

      if (!filter?.temp) {
        this.dumpUserAction({ filter })
      }
    },

    resetFilter () {
      this.applyFilter(null)
    }
  }
}
